import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { SelectOrigens } from '../SelectOrigens';
import { SelectTipo } from '../SelectTipo';
import { SelectAssunto } from '../SelectAssunto';
import { NumberSelect } from '../NumberSelect';
import { SelectAno } from '../SelectAno';
import { SelectSituacao } from '../SelectSituacao';
import { SelectData } from '../SelectData';
import Button from 'react-bootstrap/Button';

const FiltrosPesquisa = forwardRef(({
    loading,
    handleSelectionChange,
    handleSelectionTiposChange,
    handleSelectionAssuntosChange,
    handleNumberSelect,
    handleSelectionAnoChange,
    handleSelectionSituacaoChange,
    handleInitialDateChange,
    handleEndDateChange,
    handleFiltro,
    selectedNumber,
    selectedInitialDate,
    selectedEndDate
}, ref) => {
    const selectAssuntoRef = useRef(null);
    const selectOrigemRef = useRef(null);
    const selectTipoRef = useRef(null);
    const selectAnoRef = useRef(null);
    const selectNumRef = useRef(null);
    const selectSituacaoRef = useRef(null);

    // Use useImperativeHandle to expose the clear method to the parent
    useImperativeHandle(ref, () => ({
        clear() {
            if (selectAssuntoRef.current) selectAssuntoRef.current.resetSelect();
            if (selectOrigemRef.current) selectOrigemRef.current.resetSelect();
            if (selectTipoRef.current) selectTipoRef.current.resetSelect();
            if (selectAnoRef.current) selectAnoRef.current.resetSelectAno();
            if (selectSituacaoRef.current) selectSituacaoRef.current.resetSelect();
        }
    }));

    return (
        <div className="Select1">
            <div className="mb-2">
                Órgão
                <SelectOrigens onChange={handleSelectionChange} ref={selectOrigemRef} />
            </div>
            <div className="mb-2">
                Tipo
                <SelectTipo onChange={handleSelectionTiposChange} ref={selectTipoRef} />
            </div>
            <div className="mb-2">
                Assunto
                <SelectAssunto
                    onChange={handleSelectionAssuntosChange}
                    ref={selectAssuntoRef}
                />
            </div>
            <div className="mb-2">
                Número
                <NumberSelect
                    selectedNumber={selectedNumber}
                    ref={selectNumRef}
                    onSelect={handleNumberSelect}
                />
            </div>
            <div className="mb-2">
                Ano
                <SelectAno onChange={handleSelectionAnoChange} ref={selectAnoRef} />
            </div>
            <div className="d-flex flex-row mb-2">
                <div className="me-2">
                    Data inicial
                    <SelectData selectedDate={selectedInitialDate} onDateChange={handleInitialDateChange} />
                </div>
                <div>
                    Data final
                    <SelectData selectedDate={selectedEndDate} onDateChange={handleEndDateChange} />
                </div>
            </div>
            <div className="mb-4">
                Situação
                <SelectSituacao onChange={handleSelectionSituacaoChange} ref={selectSituacaoRef} />
            </div>
            <div className="d-flex justify-content-center">
                <Button
                    variant="outline-primary"
                    disabled={loading}
                    size="lg"
                    onClick={handleFiltro}
                >
                    Aplicar filtros
                </Button>
            </div>
            <div className="fixed-bottom fs-9 text-black-50">v1.2</div>
        </div>
    );
});

export default FiltrosPesquisa;
